export default {
	"classify.ProductRequestError": "商品請求錯誤",
	"classify.RequestError": "請求錯誤",
	"classify.MarketingMarketplaceListPage": "行銷商城清單頁",
	"classify.MarketingMarketplace": "行銷商城",
	"classify.all": "全部",
	"classify.CommodityAcquisition": "商品取得...",
	"classify.MarketingMarketplaceListingPageProductClick": "行銷商城清單頁_商品點擊",
	"classify.AListOfStoreItems": "店鋪商品清單"
}